export default __webpack_public_path__ + "static/media/top-games-img-one.9af94e54.png";